import { DateTime } from "luxon";
import { chosenTimesForResourceBookCalendarDay } from "../../../components/BookingForm/functions/date-time.functions";
import type { NotSerializedBookingMode } from "../../Booking-Form/typings/booking-inputs";

/**
 * Default from/until for a dashboard quick book or the colleague floor.
 * Conference rooms use the booking-form slot: today is the next quarter plus one hour,
 * any other day is the standard start plus one hour. Other types keep the workplace day.
 */
export type ResolveDashboard2QuickBookTimesOptions = {
  bookingDate: string;
  standardStartTime: string;
  standardEndTime: string;
  /** Conference uses a one-hour slot. Other modes keep the workplace day window. */
  mode?: NotSerializedBookingMode;
  timezone?: string;
};

export function resolveDashboard2QuickBookTimes({
  bookingDate,
  standardStartTime,
  standardEndTime,
  mode,
  timezone
}: ResolveDashboard2QuickBookTimesOptions): { startTime: string; endTime: string } {
  const zone = timezone ?? DateTime.now().zoneName ?? "UTC";

  return chosenTimesForResourceBookCalendarDay({
    bookingFromIso: bookingDate,
    bookingType: mode ?? undefined,
    standardEndTime,
    standardStartTime,
    timezone: zone
  });
}
